import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import CustomSwitch from "../../../components/Switch";
import { DataGridContext } from "../../../context/DataGridContext";
import GridContext from "../../../context/GridContext";
import { groupBy, newPageFill } from "../../datagrids/utils";
import OptionSelect from "./OptionSelect";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function WhitelistDialog({
  whitelistDialogOpen,
  setWhitelistDialogOpen,
  variant,
  handleSave,
  siteChanges,
  setSiteChanges,
}) {
  const { setPageArr, setNewChanges, setVariant } =
    React.useContext(GridContext);
  // console.log(whitelistDialogOpen);
  const { data } = React.useContext(DataGridContext);
  const handleClose = () => {
    setWhitelistDialogOpen(false);
  };
  // const handleWhitelist = () => {
  //   setWhitelistDialogOpen({ open: false, sites: [] });
  // };

  //   let categories = groupBy(data, data.items, function (item) {
  //     return [item.plu_details.salesGroup];
  //   });
  //   const [group, setGroup] = React.useState(categories[0]);
  //   const [autofillList, setAutofillList] = React.useState(false);

  // const handleDefaultScreen = () => {
  //   // setVariant((draft) => {
  //   //   const newList = { ...draft };
  //   //   newPageFill(
  //   //     newList,
  //   //     autofillList &&
  //   //       group?.items.filter(
  //   //         (item) =>
  //   //           item.plu_number.charAt(item.plu_number.length - 1) === "0" &&
  //   //           item.plu_isDeleted === 0
  //   //       ),
  //   //     data.colours
  //   //   );

  //   //   setPage(newList.list_details.pages);
  //   //   setPageArr(
  //   //     Array.from(Array(newList.list_details.pages), (e, i) => i + 1)
  //   //   );
  //   // });
  //   // setNewChanges(true);

  //   setWhitelistDialogOpen({ ...whitelistDialogOpen, sites: [] });
  // };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "20px",
    width: 300,
    bgcolor: "white",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 2,
  };

  //   const [alignment, setAlignment] = React.useState(whitelistDialogOpen.sites);
  // console.log(siteChanges);
  const handleAlignment = (event, i) => {
    // setAlignment(newAlignment);
    // console.log(alignment, newAlignment);
    const newScreens = [...siteChanges];
    // console.log(newScreens, i);
    newScreens[i].screen = event.target.value;
    setSiteChanges(newScreens);
    setWhitelistDialogOpen(true);
  };
  // console.log(siteChanges);
  return (
    <>
      <Dialog
        open={whitelistDialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }} id="alert-dialog-description">
            Are you sure you want to turn this variant off for the following
            site(s)?{" "}
          </DialogContentText>
          {siteChanges.map((site, i) => {
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography>Site Ref: {site.siteRef}</Typography>
                <ToggleButtonGroup
                  size="small"
                  value={site.screen}
                  exclusive
                  onChange={(event) => handleAlignment(event, i)}
                  aria-label="screen select"
                  color="primary"
                >
                  <ToggleButton size="small" value={"Whitelist"}>
                    No screen
                  </ToggleButton>
                  <ToggleButton size="small" value={"default"}>
                    Default Screen
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleSave(siteChanges)}
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
